export default __webpack_public_path__ + "third_start-121fbf.mp3";